module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av357-8ba2bcbc9409e65e4986e127c26e0d35.jpg";